import _ from 'lodash';
import React, {useState, useEffect, useContext} from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import PageContainer from "../../container/CustomPage";
import Product from "../../components/product";
import LoadMore, {NotAvailable} from "../../components/loadmore";
import Loading from "../../components/loading";
import SidebarWrap from "../../container/sidebar";
import ProductController from '../../controllers/product';
import MethodController from '../../controllers/method';
import { GlobalContext } from "../../handlers/GlobalContext";
import ErrorHandler from "../../handlers/Error";




const TemplateListWithSidebar = ({listColumnClass, sidebarPosition, showProductsPerPage}) => {
    const [ state, dispatch] = useContext(GlobalContext);
    const additionalProductsPerPage = 10;
    const productController = new ProductController();
    const methodsController = new MethodController();
    const [ productsPerPage, setProductsPerPage] = useState(showProductsPerPage || 2);
    const [ pageLoad, setPageLoad] = useState(true);
    const [ loading, setLoading] = useState(false);
    const [ searching, setSearching] = useState(false);
    const [ products, setProductsList] = useState([]);
    const [ methods, setMethods] = useState([]);
    const [ countries, setCountries] = useState([]);
    const [ shownProducts, setShownProductsList] = useState([]);
    const [ loadingMore, setLoadingMore] = useState(true);
    const [ queryState, setQueryState ] = useState({ qGeneric: '', qProduct: '', qProducer: '', qMethod: ( !!methods ? methods.map(()=>{ return false; }) : [] ), qCountry: ( !!countries ? countries.map(()=>{ return false; }) : [] ) });

    const loadMore = () => {
        setLoading(true);
        setTimeout(() => {
            let newProductPerPage = (productsPerPage + additionalProductsPerPage);
            setShownProductsList( shownProducts => [...shownProducts, ...products.slice(productsPerPage, newProductPerPage) ] )
            setProductsPerPage(newProductPerPage);
            setLoadingMore( newProductPerPage >= products.length );
            setLoading(false);
        }, 200);
    };

    const handleSearch = async(values, preloaded) => {
        setSearching(true);
        if(!!preloaded) { //If product list is loaded from general context and here just values to be loaded in the search form!
            setQueryState(Object.assign({},values));
            setSearching(false);
            return;
        }

        var queryPayload = {}
        if(!!values.qGeneric) queryPayload.GenericName = values.qGeneric;
        if(!!values.qProduct) queryPayload.MedicalalProduct = values.qProduct;
        if(!!values.qProducer) queryPayload.Manufacturer = values.qProducer;
        if(!!values.qMethod) queryPayload.PreparationMethodIds = _.filter(_.map(values.qMethod, (chk, idx) => { return !!chk ? methods[idx].preparationMethodId : -1; }), (x) => { return x > -1; } );
        if(!!values.qCountry) queryPayload.CountryIds = _.filter(_.map(values.qCountry, (chk, idx) => { return !!chk ? countries[idx].countryId : -1; }), (x) => { return x > -1; } );
        const lProducts = await productController.queryProducts(queryPayload).catch((err) => { ErrorHandler(err,'search-products-fetch',dispatch); });
        if(!!lProducts){
            setProductsList(lProducts);
            setShownProductsList(lProducts.slice(0, productsPerPage));
            setLoadingMore( productsPerPage >= lProducts.length );
        }

        setQueryState(Object.assign({},values));
        dispatch({ type: 'SET_QUERY_PRODUCTS', payload: { query: Object.assign({},values), list: lProducts}});
        setSearching(false);
        setLoading(false);
    }

    useEffect(async() => {
        if(!!loading || !!searching) return;

        setLoading(true);
        //Load methods if page load
        if(pageLoad){
            const lMethods = await methodsController.getMethods().catch((err) => { ErrorHandler(err,'search-methods-load',dispatch); });
            setMethods(lMethods);

            const lCountries = await state.locale.getCountries().catch((err) => { ErrorHandler(err,'search-countries-load',dispatch); });
            setCountries(lCountries);

            setPageLoad(false);
        }

        //Load products
        if(!!state.products) {
            let lLoadedProducts = _.concat([],state.products);
            if(!!state.query){
                handleSearch(state.query, true);
            }
            if(!!lLoadedProducts) {
                setProductsList(lLoadedProducts);
                setShownProductsList(lLoadedProducts.slice(0, productsPerPage));
                setLoadingMore( productsPerPage >= lLoadedProducts.length );
            }
            setLoading(false);
            return;
        }

        if(!!state.query){
            handleSearch(state.query, false);
            return;
        }

        setProductsList([]);
        setShownProductsList([]);
        const lProducts = await productController.queryProducts({}).catch((err) => { ErrorHandler(err,'products-fetch',dispatch); });
        if(!!lProducts){
            setProductsList(lProducts);
            setShownProductsList(lProducts.slice(0, productsPerPage));
            setLoadingMore( productsPerPage >= lProducts.length );
        }
        setLoading(false);

    },[]);

    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }


    return (
        <PageContainer classes={'bg-grey'}>
            <Container>
                <Row>
                    {
                        products.length > 0 ?
                            <Col xl={9} lg={8} className={`mb-50 ${sidebarPosition === 'left' ? 'order-2 order-lg-2': ''}`}>
                                <Row className="blog-content-wrap">
                                    {shownProducts.map(product => (
                                        <Col key={product.medicalProductId} className={listColumnClass}>
                                            <Product
                                                productId={product.medicalProductId}
                                                productName={product.productName}
                                                strength={product.strength}
                                                drugGenericName={product.genericName}
                                                producer={product.manufacturer}
                                                pharmForm={product.pharmaceuticForm}
                                            />
                                        </Col>
                                    ))}
                                </Row>

                                <Row>
                                    <LoadMore loadBlog={loadMore} totalPosts={loadingMore}/>
                                </Row>
                            </Col> :
                            <Col xl={9} lg={8} className={`mb-50 ${sidebarPosition === 'left' ? 'order-2 order-lg-2': ''}`}>
                                <Row>
                                    <NotAvailable />
                                </Row>
                            </Col>
                    }


                    <Col xl={3} lg={4} className={`${sidebarPosition === 'left' ? 'order-1 order-lg-1' : ''}`}>
                        <SidebarWrap methods={methods} countries={countries} handleSubmit={handleSearch} currentState={queryState}/>
                    </Col>
                </Row>
            </Container>

            { (!!loading || !!searching) ? <Loading/> : null}
        </PageContainer>
    );
};

export default TemplateListWithSidebar;